import React from 'react'
import './contact.scss'

const Contact = () => {
  return (
    <div>Contact</div>
  )
}

export default Contact